import ItemBaseProps from './type';
import ItemBaseStyled from './styled';

const Item = ({ children, ...props }: ItemBaseProps) => {
  return <ItemBaseStyled {...props}>{children}</ItemBaseStyled>;
};

export default Item;
